export const TO_C_HEAD = getUrl();
// C端首页地址
export const TO_C_HOME_URL = get2CUrl();
export const TO_B_HOME_URL = get2BUrl();

function getUrl() {
  if (
    window.location.href.indexOf("dev") > -1 ||
    window.location.href.indexOf("172") > -1
  ) {
    return "";
  } else if (window.location.href.indexOf("test") > -1) {
    return "";
  } else {
    return "https://www.ictxuetang.com";
  }
}
function get2BUrl() {
  if (window.location.href.indexOf("dev") > -1) {
    return "";
  } else if (window.location.href.indexOf("test") > -1) {
    return "";
  } else {
    return "https://www.ictxuetang.com/";
  }
}
function get2CUrl() {
  if (window.location.href.indexOf("dev") > -1) {
    return "";
  } else if (window.location.href.indexOf("test") > -1) {
    return "https://www.ictxuetang.com/";
  } else {
    return "https://www.ictxuetang.com/";
  }
}

export const coursewareListMap = {
  pageNum: 1,
  pageSize: 10,
  totalCount: 3,
  list: [
    {
      id: "867433193501188190",
      name: "MPEG-4编码MP4视频2M.mp4",
      type: 1,
      status: 1,
      operator: "李教授",
      realName: "MPEG-4编码MP4视频2M",
      suffix: ".mp4",
      tags: [],
      createTime: "2021-07-21T15:49:19.000+0000",
      createUser: "qiu124",
      updateTime: "2021-07-21T15:49:09.000+0000",
      updateUser: "qiu124",
      url: "service-aggregation/5aea0eff_1.mp4"
    },
    {
      createTime: "2021-07-21T15:49:49.000+0000",
      createUser: "qiu124",
      id: "867433193501188101",
      name: "MPEG-4编码MP4视频29M.mp4",
      realName: "MPEG-4编码MP4视频29M",
      operator: "教授",
      suffix: ".mp4",
      tags: [],
      type: 1,
      status: 2,
      updateTime: "2021-07-21T15:49:59.000+0000",
      updateUser: "qiu124",
      url: "service-aggregation/5aea0eff_1.mp4"
    },
    {
      createTime: "2021-07-21T15:49:39.000+0000",
      createUser: "qiu124",
      id: "867433193501188102",
      name: "MPEG-4编码MP4视频292M.mp4",
      realName: "MPEG-4编码MP4视频292M",
      operator: "王子",
      suffix: ".mp4",
      tags: [],
      type: 1,
      status: 2,
      updateTime: "2021-07-21T15:49:49.000+0000",
      updateUser: "qiu124",
      url: "service-aggregation/5aea0eff_1.mp4"
    }
  ]
};
